import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";
const initialState = {
    ingredients:null,
    totalPrice: 40,
    error: false,
    building: false
};
const INGREDIENT_PRICES = {
    salad: 30,
    cheese: 40,
    meat: 75,
    bacon: 30
}
const addIngredient = (state, action ) => {
    const updatedIngredient =  { [action.ingredientName]: state.ingredients[action.ingredientName] +1};
            const updatedIngredients = updateObject(state.ingredients, updatedIngredient);
            const updatedState = {
                ingredients: updatedIngredients,
                totalPrice: state.totalPrice + INGREDIENT_PRICES[action.ingredientName],
                building: true
            }
            return updateObject(state, updatedState);
}
const removeIngredient = ( state, action ) => {
    const updatedIng =  { [action.ingredientName]: state.ingredients[action.ingredientName] -1};
            const updatedIngs = updateObject(state.ingredients, updatedIng);
            const updatedSt = {
                ingredients: updatedIngs,
                totalPrice: state.totalPrice - INGREDIENT_PRICES[action.ingredientName],
                building: true
            };
            return updateObject(state, updatedSt);
}
const setIngredient = (state, action ) => {
    return updateObject(state, {
        ingredients:{
            salad: action.ingredients.salad,
            bacon: action.ingredients.bacon,
            meat: action.ingredients.meat,
            cheese: action.ingredients.cheese
        },
        totalPrice: 40,
        error: false,
        building: false
    }
    );
}
const FetchIngredientFailed = ( state, action ) => {
    return updateObject(state, {error: true});
}

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.ADD_INGREDIENT: return addIngredient( state, action);
        case actionTypes.REMOVE_INGREDIENT: return removeIngredient(state, action);
        case actionTypes.SET_INGREDIENT: return setIngredient(state, action);
        case actionTypes.FETCH_INGREDIENT_FAILED: return FetchIngredientFailed( state, action);
        default:
            return state;
    }
   
};

export default reducer;